// auth
export const AUTH_LOGGED_IN = 'AUTH_LOGGED_IN'
export const AUTH_LOGGED_OUT = 'AUTH_LOGGED_OUT'

// user
export const USER_FETCH_INFO = 'USER_FETCH_INFO'
export const USER_FETCH_CLIENTS = 'USER_FETCH_CLIENTS'
export const USER_SET_PERMISSIONS = 'USER_SET_PERMISSIONS'
export const USER_SET_DEFAULT_MENU_ITEM = 'USER_SET_DEFAULT_MENU_ITEM' // Aurus TI : WCR 26/12/2023
export const USER_SET_SLIDE_MENU_ITEMS = 'USER_SET_SLIDE_MENU_ITEMS'

// dashboard
export const DASHBOARD_RESET_FILTER = 'DASHBOARD_RESET_FILTER'
export const DASHBOARD_SET_FILTER_DATE = 'DASHBOARD_SET_FILTER'
export const DASHBOARD_SET_FILTER_CLIENT = 'DASHBOARD_SET_FILTER_CLIENT'

// inventory
export const INVENTORY_SET_ITEMS = 'INVENTORY_SET_ITEMS'
export const INVENTORY_SET_LINES = 'INVENTORY_SET_LINES'
export const INVENTORY_RESET_VALUES = 'INVENTORY_RESET_VALUES'
export const INVENTORY_SET_STATUSES = 'INVENTORY_SET_STATUSES'

// product
export const PRODUCT_SET_MODES = 'PRODUCT_MODES'
export const PRODUCT_RESET_VALUES = 'PRODUCT_RESET_VALUES'

// monitoring
export const MONITORING_DOCUMENT_TYPES_RESET = 'MONITORING_DOCUMENT_TYPES_RESET'
export const MONITORING_SET_DOCUMENT_TYPES = 'MONITORING_SET_DOCUMENT_TYPES'
export const MONITORING_DOCUMENT_SEARCH_RESET = 'MONITORING_DOCUMENT_SEARCH_RESET'
export const MONITORING_SET_DOCUMENT_SEARCH = 'MONITORING_SET_DOCUMENT_SEARCH'
export const MONITORING_SET_DOCUMENT_SEARCH_PAGE = 'MONITORING_SET_DOCUMENT_SEARCH_PAGE'
export const MONITORING_SET_DOCUMENT_IMAGE = 'MONITORING_SET_DOCUMENT_IMAGE'

// orderprogress
export const ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER = 'ORDERPROGRESS_DOCUMENT_SUPPLIERCUSTOMER'
export const ORDERPROGRESS_TYPES_ORDER = 'ORDERPROGRESS_TYPES_ORDER'
export const ORDERPROGRESS_DOCUMENT_STATUS = 'ORDERPROGRESS_DOCUMENT_STATUS'
export const ORDERPROGRESS_SET_ORDER_SEARCH = 'ORDERPROGRESS_SET_ORDER_SEARCH'
export const ORDERPROGRESS_SET_ORDER_RESET = 'ORDERPROGRESS_SET_ORDER_RESET'

// traking ATI : WCR
export const TRACKING_SET_ORDER_TYPES = 'TRACKING_SET_ORDER_TYPES'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js